// Socket "email" events in arrival order. The store used to keep only the
// latest payload, so when two events landed before LatestMessages rendered
// (two accounts syncing, "increase" right before "updated") the first one
// never reached the list. Each event gets a sequence number; consumers apply
// everything after the last number they handled.

export const EMAIL_SYNC_QUEUE_MAX = 50;

export function appendEmailSyncEvent(queue, payload, seq) {
  return [...(queue || []), { ...payload, __seq: seq }].slice(-EMAIL_SYNC_QUEUE_MAX);
}

/**
 * Events newer than `lastSeq`, plus whether some were already dropped from
 * the bounded queue (the consumer should then re-fetch instead).
 */
export function emailSyncEventsAfter(queue, lastSeq) {
  const events = (queue || []).filter((e) => e.__seq > lastSeq);
  const missed = events.length > 0 && events[0].__seq > lastSeq + 1;
  return { events, missed };
}

export function latestEmailSyncSeq(queue) {
  const q = queue || [];
  return q.length ? q[q.length - 1].__seq : 0;
}
